import script from "./contact-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact-modal.vue?vue&type=script&setup=true&lang=ts"

import "./contact-modal.vue?vue&type=style&index=0&id=ad9a7282&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad9a7282"]])

export default __exports__